module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="top-ad-banner"></div>\n<div class="fixture-coming-soon">\n	<div class="text-block">\n		<h5>LEAGUE FIXTURES WILL BECOME AVAILABLE WHEN YOUR LEAGUE IS FULL</h5>\n	</div>\n</div>\n';
}
return __p;
};
